import { ResponseObject } from '#/interfaces';
import request from '#/utils/request';
import useSWR from 'swr';

/**
 * useEthereumCurrentEpoch
 */
export default function useCurrentEpoch() {
  return useSWR(
    '/api/v2/eth2/currentEpoch',
    url => request.post<ResponseObject<number>>(url),
    {
      refreshInterval: 60_000,
      keepPreviousData: true,
    }
  );
}

export function useIsCurrentEpochPastTarget(
  targetEpoch: number,
  minGap: number
) {
  const { data } = useCurrentEpoch();
  return data?.data.data != null && data.data.data - targetEpoch > minGap;
}
